module.exports = __webpack_public_path__ + "static/media/XIIIe.8d30af83.png";